import { Component, OnInit, Inject, HostListener, ViewChild, ElementRef, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/_services/api.service';
import {TabDirective, TabsetComponent} from 'ngx-bootstrap/tabs';

@Component({
    selector: 'app-DataSales',
    templateUrl: './DataSales.component.html',
    styleUrls: ['./DataSales.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DataSalesComponent implements OnInit, AfterViewInit {
  @ViewChild('staticTabs', { static: false }) staticTabs: TabsetComponent;
  pageId: string;
  pageName = "Data Sales";
  id = 0;
  open=true;
  tab='General Info'
  enable = true;
  randomBool = true;
  FaqData: any;
  FormData: any;
  date = new Date().getFullYear();

  selectTab(tabId: number) {
    this.staticTabs.tabs[tabId].active = true;
    this.id = tabId + 1;
  }

  constructor(private actRoute: ActivatedRoute,  private apiService: ApiService,) {
    this.id = this.actRoute.snapshot.params.id || null;
  }

  onSelect(data: TabDirective): void {
    this.tab = data.heading();
    // console.log('tab ' + this.tab);
    if(!this.pageId) {

      this.apiService.getPage(this.pageName).subscribe(data => {
        this.pageId = data.id.toString();
        if(this.tab.toLowerCase() === 'faq') {
          this.getFaq();
        }
        else if(this.tab.toLowerCase() == 'forms') {
          this.getForm();
        }

      })
    }
    else {
      if(this.tab.toLowerCase() === 'faq') {
        this.getFaq();
      }
      else if(this.tab.toLowerCase() == 'forms') {
        this.getForm();
      }

    }

  }
  getFaq() {
    // console.log(this.pageName)
    this.apiService.getFaqByPage(this.pageId).subscribe(data => {
      this.FaqData = data;
      // console.log(data);
    })

  }

  getForm() {
    this.apiService.getFormByPage(this.pageId).subscribe(data => {
      this.FormData = data;

    })
  }

  ngAfterViewInit() {
    if(this.id !== null)
      this.selectTab(this.id - 1);
  }
  ngOnInit() {
  }

}
